<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>出版適正チェック</h1>
                            <h2>論文受理の可能性を高める英文チェックを</h2>
                            <p>Trinka（トリンカ）の出版適正チェック機能では、20以上のチェックポイントで学術的な英文を査定し、論文受理の可能性を高めます。ジャーナルとの相性も判定します。</p>
                            <div class="btn-group">
                                <a href="https://cloud.trinka.ai/signup?_rg=JP" class="filled-btn" target="_blank">今すぐ始める</a>
                            </div>
                        </div>
                        <div class="top-banner-right">
                            <div class="toolbox_img_content publication_checks_icons publication_checks_section">
                                <ul>
                                    <li>
                                        <div class="checks_icons">
                                            <img src="assets/images/JournalScope.svg" class="auto-height" alt="ジャーナルの範囲 - 文法 チェック ">
                                        </div>
                                        <h3>Journal Scope Match</h3>
                                        <span>2 Checks</span>
                                    </li>
        
                                    <li>
                                        <div class="checks_icons">
                                            <img src="assets/images/TechnicalCompliance.svg" class="auto-height" alt="テクニカル - 英文校正">
                                        </div>
                                        <h3>Technical Compliances</h3>
                                        <span>3 Checks</span>
                                    </li>
        
                                    <li>
                                        <div class="checks_icons">
                                            <img src="assets/images/EthicalCompliance.svg" class="auto-height" alt="倫理遵守 - 文法 チェック">
                                        </div>
                                        <h3>Ethical Compliance</h3>
                                        <span>5 Checks</span>
                                    </li>
        
                                    <li>
                                        <div class="checks_icons">
                                            <img src="assets/images/AuthorshipDetails.svg" class="auto-height" alt="著者の船 - 文法 チェック">
                                        </div>
                                        <h3>Authorship Details</h3>
                                        <span>4 Checks</span>
                                    </li>
                                    <li>
                                        <div class="checks_icons">
                                            <img src="assets/images/ReferenceDetails.svg" class="auto-height" alt="参照 - 英文チ ェッカー">
                                        </div>
                                        <h3>Reference Details</h3>
                                        <span>1 Check</span>
                                    </li>
        
                                    <li>
                                        <div class="checks_icons">
                                            <img src="assets/images/FirgureTable.svg" class="auto-height" alt="図表 - 文法 チェック">
                                        </div>
                                        <h3>Figures & Tables</h3>
                                        <span>2 Checks</span>
                                    </li>
        
                                    <li>
                                        <div class="checks_icons">
                                            <img src="assets/images/ClinicalTrials.svg" class="auto-height" alt="臨床試験 - 文法 チェック">
                                        </div>
                                        <h3>Clinical Trial Information</h3>
                                        <span>1 Check</span>
                                    </li>
        
                                    <li>
                                        <div class="checks_icons">
                                            <img src="assets/images/KeywordsAndSummary.svg" class="auto-height" alt="キーワード - 文法 チェック">
                                        </div>
                                        <h3>Keywords & Summary</h3>
                                        <span>2 Checks</span>
                                    </li>
                                    <i></i>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="howItWorks section-pd list-wrapper-style-2" #viewVideo>
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/PublicationCheckThumbnail.png" alt="出版物チェック - 文法 チェック" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2">
                        <div class="trinka-title mb-0">
                            <h2>出版適正チェックの使い方</h2>
                            <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                            <p>チュートリアル動画で、出版適正チェックの使い方をご案内します。</p>
                            <p>ステップごとの解説で、機能を余すところなくお使いいただけます</p>
                            <p class="mb-0">疑問点については
                                <a style="color: #0000ff;" (click)="scroll(target)" class="text-link remove-left-space">FAQ</a>もあわせてお読みください。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>出版適正チェックの特徴</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <img src="assets/images/JournalScope.svg" alt="ジャーナルの範囲 - 英文校正">
                        <h3>投稿先ジャーナルへの適合性</h3>
                        <p>論文の内容が、投稿先ジャーナルが対象とする分野に適合しているかをチェックし、必要に応じて代替ジャーナルをご提案します。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <img src="assets/images/TechnicalCompliance.svg" alt="技術コンプライアンス - 英文チ ェッカー ">
                        <h3>学術論文としての体裁</h3>
                        <p>要旨（アブストラクト）、単語数、段落の構成など、学術論文に一般的に必要な要素をチェックし、学術論文としての体裁が整っているかどうかチェックします。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <img src="assets/images/EthicalCompliance.svg" alt="倫理的な - 英文校正">
                        <h3>倫理規定の順守</h3>
                        <p>ジャーナル編集部が原稿を受理できるよう、インフォームドコンセントや、倫理規定に関する関係者の同意、研究資金や利益相反についての情報開示など必要な記述がなされているかをチェックします。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <img src="assets/images/AuthorshipDetails.svg" alt="著者の船 - 文法 チェック">
                        <h3>オーサーシップの記載</h3>
                        <p>著者名、所属組織との関わり、責任著者、論文への貢献度など、研究論文のオーサーシップについて明記されているかをチェックします。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <img src="assets/images/ReferenceDetails.svg" alt="参照 - 英文校正 " width="26" height="34">
                        <h3>参考文献</h3>
                        <p>Trinkaでは参考文献もチェックし、文献が古すぎる場合は指摘します。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <img src="assets/images/FirgureTable.svg" alt="図表 - 英文 チェック">
                        <h3>図表</h3>
                        <p>図表のキャプションが記載されているかどうか、また図表が論文内できちんと引用されているかどうかもチェックします。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <img src="assets/images/ClinicalTrials.svg" alt="臨床的 - 英文校正" width="29" height="35">
                        <h3>臨床試験情報</h3>
                        <p>Trinkaでは、臨床試験IDなど試験に関する詳細が明記されているかもチェックします。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <img src="assets/images/KeywordsAndSummary.svg" alt="キーワード - ai英文校正">
                        <h3>キーワードと要約</h3>
                        <p>Trinkaでは最先端のAI技術により、論文の要点やトピックを抽出し、要旨（アブストラクト）やイントロダクションなど論文の構成要素ごとに要約を自動生成します。また、キーワード候補も提示します。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd pt-0">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>出版適正チェックレポートのサンプル</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="viewSampleReportImg">
                        <img src="assets/images/PublicationReportImg.png" alt="出版レポート - 文法 チェック">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">出版にふさわしい英語を、Trinkaで</h3>
                    </div>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" class="white-btn" target="_blank">今すぐ始める</a>
                    </div>
                </div>
            </div>  
        </div>
    </div>

    <div class="trinka-credits section-pd">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinkaトークン利用で出版適正をチェック</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-10">
                    <div class="credit-section">
                        <div class="shape">
                            <svg xmlns="http://www.w3.org/2000/svg" width="745" height="140" viewBox="0 0 745 140" fill="none">
                                <path d="M210.74 99.3391C92.7255 118.025 21.074 68.6063 0 41.5614V169H721.602C749.822 122.013 775.522 23.2037 652.567 3.86251C498.872 -20.314 358.258 75.9822 210.74 99.3391Z" fill="#F5ECFF"/>
                            </svg>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <img src="assets/images/new-credits.svg" alt="クレジット - 英文校正" />
                            </div>
                            <div class="media-body">
                                <h6>1ポイントにつき1レポートを生成可。ご利用プランのアカウントに無料で付与されるポイントに加え、必要に応じて追加でご購入もいただけます。</h6>
                            </div>
                        </div>
                        <div class="image">
                            <img src="assets/images/credits-banner.svg" alt="クレジット - 文法 チェック" />
                        </div>
                    </div>
                    <ul>
                        <li><span>*</span>
                            <p>
                                ご利用いただくTrinkaの機能に応じ、ポイントが消費されます。<br/>
                                プレミアムプランをご利用の方には10ポイント、ベーシックプランをご利用の方には4ポイントが毎月無料で付与されます。詳しくは
                                    <a  [routerLink]="['/features/credits']" class="link">こちら</a>をご覧ください。
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="faqQuestionAnwser section-pd pt-0" #target>
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-10">
                    <div class="trinka-title text-center">
                        <h2>よくあるご質問</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="faqQuestionsList">
                <div class="accordion" id="faq">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionOne">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                            出版適正チェックに必要なポイント数（Credit）を教えてください。</a>
                                    </div>
    
                                    <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                        <div class="card-body">
                                            <p>出版適正チェック1件ごとに1ポイントが消費されます。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionTwo">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                            aria-controls="QuestionTwoContent">
                                            出版適正チェックのレポートはダウンロードできますか？</a>
                                    </div>
    
                                    <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                        <div class="card-body">
                                            <p>現時点では、出版適正チェックのレポートはダウンロードいただけませんが、Trinka Cloud上でいつでも閲覧可能です。登録されたメールアドレスにも各レポートへのリンクが送信されます。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionThree">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                            aria-controls="QuestionThreeContent">
                                            Trinkaのベーシックプランでも、出版適正チェックの機能は利用できますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                        <div class="card-body">
                                            <p>はい。出版適正チェックの利用には1回ごとに1ポイントが必要ですが、ベーシックプランのユーザーには、毎月無料で4ポイントが付与されます。付与されたポイントは、出版適正チェックにもご利用いただけます。
                                            </p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionFour">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                            aria-controls="QuestionFourContent">
                                            出版適正チェックはどのように活用できますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                        <div class="card-body">
                                            <p>出版適正チェックのレポートをチェックリストとして使用することで、投稿先ジャーナルの要件に照らし合わせて論文の出版適正を判断できます。レポートについてご理解いただくための
                                                <a style="color: #0000ff;" (click)="scroll(viewVideo)" class="text-link">チュートリアルビデオ</a> もご用意しています。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="otherApps section-pd-sm">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">もっとあります
                            Trinkaの
                            使い方</h3>
                    </div>
                    <ul>
                        <li>
                            <a [routerLink]="['/trinkacloud']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="cloud - 文法 チェック">
                                    <h3>Cloud</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/wordplugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Others_App_MSWord.svg" alt="ms word - 文法 チェック">
                                    <h3><span class="OpenSansFonts" style="font-weight: bold;">MS Word</span>
                                        <br /> プラグイン</h3>
                                </div>
                        </a>
                        </li>
                        <li>
                            <a [routerLink]="['/browser-plugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/other_Apps_browser.svg" alt="browser - 文法 チェック">
                                    <h3>ブラウザ
                                        <br />プラグイン</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/enterprise']">
                                <div class="app_name_content" style="padding: 0px;">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_Apps_enterprise.svg" alt="enterprise - 文法 チェック">
                                    <h3 style="margin: 0 0 -2px 0;">Enterprise</h3>
                                    <span style="font-size: 12px; color: #000; position: relative;">(API, JS, & On-Premise)</span>
                                </div>
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel
                               " aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/c8yyiW2tEjE"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media;
                                gyroscope; picture-in-picture" allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write;
                                encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>